export const FeedbackResourceBS: FeedbackInterface = {
  title: "Feedback",
  description: "Molimo podijelite svoje mišljenje ili prijedloge",
  fields: {
    date: {
      label: "Datum",
      placeholder: "Odaberite datum",
    },
    time: {
      label: "Vrijeme",
      placeholder: "Odaberite vrijeme",
    },
    anonymous: {
      label: "Anonimno",
      dataEntry: "Unos podataka",
    },
    email: {
      label: "Email",
      placeholder: "Unesite email adresu",
    },
    phone: {
      label: "Telefon",
      placeholder: "Unesite broj telefona",
    },
    comment: {
      label: "Primjedba / pohvala",
      placeholder: "Unesite vašu primjedbu ili pohvalu",
    },
    images: {
      label: "Upload slika",
      description: "Povucite i pustite slike ovdje ili kliknite da odaberete",
      maxSize: "Maksimalna veličina: 12 MB",
      multiple: "Možete odabrati više slika",
    },
  },
  buttons: {
    submit: "Pošalji",
    cancel: "Otkaži",
  },
  messages: {
    success: "Feedback je uspješno poslan!",
    error: "Došlo je do greške. Molimo pokušajte ponovo.",
    required: "Ovo polje je obavezno",
    invalidEmail: "Unesite validnu email adresu",
    fileTooLarge: "Fajl je prevelik. Maksimalna veličina je 12 MB",
    onlyImagesAllowed: "Samo slike su dozvoljene",
    emailOrPhoneRequired: "Molimo unesite email ili telefon",
    missingParameters: "Nedostaju potrebni parametri",
    missingParametersUrl: "Nedostaju potrebni parametri u URL-u",
    loading: "Učitavanje...",
    captchaError: "Došlo je do greške tokom provjere. Molimo pokrenite stranicu ponovo. Ako se greška ponovi, kontaktirajte administratora.",
  },
};

export const FeedbackResourceEN: FeedbackInterface = {
  title: "Feedback",
  description: "Please share your opinion or suggestions",
  fields: {
    date: {
      label: "Date",
      placeholder: "Select date",
    },
    time: {
      label: "Time",
      placeholder: "Select time",
    },
    anonymous: {
      label: "Anonymous",
      dataEntry: "Data Entry",
    },
    email: {
      label: "Email",
      placeholder: "Enter email address",
    },
    phone: {
      label: "Phone",
      placeholder: "Enter phone number",
    },
    comment: {
      label: "Comment / Praise",
      placeholder: "Enter your comment or praise",
    },
    images: {
      label: "Upload Images",
      description: "Drag and drop images here or click to select",
      maxSize: "Maximum size: 12 MB",
      multiple: "You can select multiple images",
    },
  },
  buttons: {
    submit: "Submit",
    cancel: "Cancel",
  },
  messages: {
    success: "Feedback has been successfully sent!",
    error: "An error occurred. Please try again.",
    required: "This field is required",
    invalidEmail: "Enter a valid email address",
    fileTooLarge: "File is too large. Maximum size is 12 MB",
    onlyImagesAllowed: "Only images are allowed",
    emailOrPhoneRequired: "Please enter email or phone",
    missingParameters: "Missing required parameters",
    missingParametersUrl: "Missing required parameters in URL",
    loading: "Loading...",
    captchaError: "An error occurred during verification. Please reload the page. If the error persists, please contact the administrator.",
  },
};

export const FeedbackResourceDE: FeedbackInterface = {
  title: "Feedback",
  description: "Bitte teilen Sie Ihre Meinung oder Vorschläge mit",
  fields: {
    date: {
      label: "Datum",
      placeholder: "Datum auswählen",
    },
    time: {
      label: "Zeit",
      placeholder: "Zeit auswählen",
    },
    anonymous: {
      label: "Anonym",
      dataEntry: "Dateneingabe",
    },
    email: {
      label: "E-Mail",
      placeholder: "E-Mail-Adresse eingeben",
    },
    phone: {
      label: "Telefon",
      placeholder: "Telefonnummer eingeben",
    },
    comment: {
      label: "Kommentar / Lob",
      placeholder: "Geben Sie Ihren Kommentar oder Ihr Lob ein",
    },
    images: {
      label: "Bilder hochladen",
      description: "Bilder hierher ziehen und ablegen oder klicken, um auszuwählen",
      maxSize: "Maximale Größe: 12 MB",
      multiple: "Sie können mehrere Bilder auswählen",
    },
  },
  buttons: {
    submit: "Absenden",
    cancel: "Abbrechen",
  },
  messages: {
    success: "Feedback wurde erfolgreich gesendet!",
    error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    required: "Dieses Feld ist erforderlich",
    invalidEmail: "Geben Sie eine gültige E-Mail-Adresse ein",
    fileTooLarge: "Datei ist zu groß. Maximale Größe ist 12 MB",
    onlyImagesAllowed: "Nur Bilder sind erlaubt",
    emailOrPhoneRequired: "Bitte geben Sie E-Mail oder Telefon ein",
    missingParameters: "Erforderliche Parameter fehlen",
    missingParametersUrl: "Erforderliche Parameter fehlen in der URL",
    loading: "Laden...",
    captchaError: "Bei der Überprüfung ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu. Wenn der Fehler weiterhin besteht, kontaktieren Sie bitte den Administrator.",
  },
};

export interface FeedbackInterface {
  title: string;
  description: string;
  fields: {
    date: {
      label: string;
      placeholder: string;
    };
    time: {
      label: string;
      placeholder: string;
    };
    anonymous: {
      label: string;
      dataEntry: string;
    };
    email: {
      label: string;
      placeholder: string;
    };
    phone: {
      label: string;
      placeholder: string;
    };
    comment: {
      label: string;
      placeholder: string;
    };
    images: {
      label: string;
      description: string;
      maxSize: string;
      multiple: string;
    };
  };
  buttons: {
    submit: string;
    cancel: string;
  };
  messages: {
    success: string;
    error: string;
    required: string;
    invalidEmail: string;
    fileTooLarge: string;
    onlyImagesAllowed: string;
    emailOrPhoneRequired: string;
    missingParameters: string;
    missingParametersUrl: string;
    loading: string;
    captchaError: string;
  };
}

